const TOGGLE_CATEGORY_TO_BE_SEARCHED_CHECK =
  "TOGGLE_CATEGORY_TO_BE_SEARCHED_CHECK";
const SET_CATEGORY_TO_BE_SEARCHED_CHECK = "SET_CATEGORY_TO_BE_SEARCHED_CHECK";
export {
  TOGGLE_CATEGORY_TO_BE_SEARCHED_CHECK,
  SET_CATEGORY_TO_BE_SEARCHED_CHECK,
};
